import { type TAudioSimple as TApiAudioSimple } from '@core/api'

import { type TAudioSimple } from '@core/models'

import { convertAudioSourceFile } from './convertAudioSourceFile'
import { convertCrossLinkTag } from './convertCrossLinkTag'
import { convertGenre } from './convertGengre'

export const convertAudioSimple = (apiAudioSimple: TApiAudioSimple): TAudioSimple => {
    const {
        author,
        category,
        description,
        downloadable,
        browsable,
        id,
        image,
        listed,
        play,
        playhq,
        slug,
        title,
        user,
        username,
        avatar,
        source,
        stats,
        tags,
        transcribed,
        created,
        options,
        license,
        metadata,
        price,
        scraped_from,
        cross_link_tags,
    } = apiAudioSimple

    return {
        id,
        authorId: user,
        authorDisplayName: author,
        authorUsername: username,
        avatarUrl: avatar,
        categoryId: category,
        description,
        imageUrl: image,
        isDownloadable: downloadable,
        isPublic: listed,
        isBrowsable: browsable,
        slug,
        title,
        duration: play.duration,
        peaksUrl: play.waveform,
        transcodingUrl: play.url,
        transcodingUrlHq: playhq.url,
        source: convertAudioSourceFile(source),
        playsCount: stats.plays_count,
        downloadsCount: stats.downloads_count,
        sharesCount: stats.shares_count,
        commentsCount: stats.comments_count,
        likesCount: stats.likes_count,
        tags,
        transcribed,
        dateCreated: created,
        options: {
            transcribe: options.transcribe,
        },
        license,
        price,
        metadata,
        scrapedFrom: scraped_from,
        genres: apiAudioSimple.genres ? apiAudioSimple.genres.map(convertGenre) : undefined,
        crossLinkTags: (cross_link_tags ?? []).map(convertCrossLinkTag),
    }
}
